import React from "react";

import { Summary } from "affinityUI/data/summary";

export const SummaryBuilder: React.FC<{ fields: { label: string; description?: Maybe<React.ReactNode> }[] }> = ({
  fields,
}) => (
  <Summary.List>
    {fields.map(({ label, description }) => (
      <Summary.Item key={label} label={label}>
        {description}
      </Summary.Item>
    ))}
  </Summary.List>
);
